import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import UserHeader from '@/components/user/UserHeader';
import Footer from '@/components/layout/Footer';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <UserHeader />
      
      <div className="flex-grow flex flex-col items-center justify-center p-6">
        <div className="text-center max-w-lg">
          <div className="flex justify-center mb-6">
            <div className="text-[120px] font-bold text-[#0e7cb4]">404</div>
          </div>
          
          <h1 className="text-3xl font-bold text-gray-800 mb-4">Opa! Página não encontrada</h1>
          
          <p className="text-gray-600 mb-8">
            A página que você está procurando não existe ou foi movida.
            Verifique o endereço digitado ou use o botão abaixo para voltar à página inicial.
          </p>
          
          <Button 
            className="bg-[#0e7cb4] hover:bg-[#0a5c87] text-white font-medium py-2 px-6"
            onClick={() => navigate('/')}
          >
            Voltar para casa
          </Button>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default NotFound;
